import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { setShowWeekends } from '../../../store/calendar';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

const useStyles = makeStyles()({});

export default function ShowWeekendsCheckbox() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const showWeekends = useAppSelector(state => state.calendar?.showWeekends || false);

    const handleToggleWeekends = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setShowWeekends(event.target.checked));
    };

    return (
        <FormControl component="fieldset">
            <FormGroup>
                <FormControlLabel
                    value="ShowWeekends"
                    control={
                        <Checkbox
                            color="primary"
                            onChange={handleToggleWeekends}
                            checked={showWeekends}
                        />
                    }
                    label="Weekends"
                    labelPlacement="end"
                />
            </FormGroup>
        </FormControl>
    );
}
